import React, { useState, useEffect } from 'react';

import './styles.css';

import ListOption from './ListOption';

// Um array de opções deve ser passado para o componente
// Caso a lista seja para ordenação, deve indicar com a flag isToOrder
// Ativar a flag devView para mostrar no componente o retorno (x, y)
//      sendo x o botão selecionado e y a configuração da ordenação

// PENDENTE: Conseguir pegar o option e o order do component

export default function ListOptions(props) {
    const [option, setOption] = useState(0);
    const [orderOption, setOrderOption] = useState(0);

    useEffect(() => {
        if (props.optionInfos !== undefined && props.optionInfos !== option)
            setOption(props.optionInfos);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.optionInfos]);

    useEffect(() => {
        if (props.setOptionInfos) {
            if (props.isToOrder)
                props.setOptionInfos([option, orderOption]);
            else
                props.setOptionInfos(option);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [option, orderOption]);

    return (
        <div className='list-options'>
            <p>{props.devView ? `(${option}, ${orderOption})` : []} {props.title}:</p>
            {
                props.options.map((item, index) =>
                    <ListOption
                        isToOrder={props.isToOrder}
                        key={index}
                        item={item}
                        index={index}
                        option={option}
                        setOption={setOption}
                        setOrderOption={setOrderOption}
                    />
                )
            }
        </div>
    )
}